import { render, staticRenderFns } from "./PromotionRowOfferLabel.vue?vue&type=template&id=f263e99a&scoped=true"
import script from "./PromotionRowOfferLabel.vue?vue&type=script&lang=ts&setup=true"
export * from "./PromotionRowOfferLabel.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./PromotionRowOfferLabel.vue?vue&type=style&index=0&id=f263e99a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f263e99a",
  null
  
)

export default component.exports